jQuery(() => {
  const hasGsap = () => typeof window.gsap !== 'undefined';

  function getBox(methodName) {
    return jQuery(`.mad-checkout-payment__payment-method-box[data-payment-method="${methodName}"]`)
  }

  function openPaymentMethod(methodName, animate = true) {
    let paymentMethodBox = getBox(methodName)

    let boxHeight = 0;

    for (const child of paymentMethodBox.children()) {
      boxHeight = boxHeight + jQuery(child).outerHeight(true);
    }

    if (!hasGsap()) {
      paymentMethodBox.css('height', 'fit-content');
    } else if (animate) {
      gsap.to(paymentMethodBox, {
        height: boxHeight,
        duration: 0.4
      })
      gsap.set(paymentMethodBox, {
        height: 'fit-content',
        delay: 0.5
      })
    } else {
      gsap.set(paymentMethodBox, {
        height: 'fit-content',
      })
    }
  }

  function closeAllPaymentMethods(skipMethodName) {

    jQuery(`.mad-checkout-payment__payment-method-box`).each((i, paymentMethodBox) => {
      if (jQuery(paymentMethodBox).attr('data-payment-method') != skipMethodName) {
        if (!hasGsap()) {
          jQuery(paymentMethodBox).css('height', 0);
          return;
        }

        gsap.set(paymentMethodBox, {
          height: jQuery(paymentMethodBox).outerHeight(),
        })

        gsap.to(paymentMethodBox, {
          height: 0,
          duration: 0.4
        })
      }

    })

  }

  function openCheckedPaymentMethod() {
    var methodName = jQuery('.mad-checkout-payment__payment-method > input[name="payment_method"]:checked').parent().attr('data-payment-method')

    if (methodName != null) {
      openPaymentMethod(methodName, false)
    }
  }

  // Delegated: WooCommerce replaces the payment section via AJAX (update_order_review)
  jQuery(document).on('change', '.mad-checkout-payment__payment-method > input[name="payment_method"]', (event) => {
    var input = event.target
    var methodName = jQuery(input).parent().attr('data-payment-method')

    if (input.checked) {
      closeAllPaymentMethods(methodName)
      if (methodName != null) {
        openPaymentMethod(methodName)
      }
    }
  })

  jQuery(document.body).on('updated_checkout', openCheckedPaymentMethod)

  openCheckedPaymentMethod()
})
